import { render, staticRenderFns } from "./CompletedTest.vue?vue&type=template&id=ff4821ea&scoped=true&"
import script from "./CompletedTest.vue?vue&type=script&lang=js&"
export * from "./CompletedTest.vue?vue&type=script&lang=js&"
import style0 from "./CompletedTest.vue?vue&type=style&index=0&id=ff4821ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4821ea",
  null
  
)

export default component.exports